export const UPDATE_ACCESS_TEMPLATE = "UPDATE_ACCESS_TEMPLATE";
export const UPDATE_ACCESS_TEMPLATE_SUCCESS = "UPDATE_ACCESS_TEMPLATE_SUCCESS";
export const UPDATE_ACCESS_TEMPLATE_FAIL = "UPDATE_ACCESS_TEMPLATE_FAIL";

export const ADD_ACCESS_TEMPLATE = "ADD_ACCESS_TEMPLATE";
export const ADD_ACCESS_TEMPLATE_SUCCESS = "ADD_ACCESS_TEMPLATE_SUCCESS";
export const ADD_ACCESS_TEMPLATE_FAIL = "ADD_ACCESS_TEMPLATE_FAIL";

export const ACCESS_TEMPLATE_LIST = "ACCESS_TEMPLATE_LIST";
export const ACCESS_TEMPLATE_LIST_SUCCESS = "ACCESS_TEMPLATE_LIST_SUCCESS";
export const ACCESS_TEMPLATE_LIST_FAIL = "ACCESS_TEMPLATE_LIST_FAIL";

export const ASSIGN_ACCESS = "ASSIGN_ACCESS";
export const ASSIGN_ACCESS_SUCCESS = "ASSIGN_ACCESS_SUCCESS";
export const ASSIGN_ACCESS_FAIL = "ASSIGN_ACCESS_FAIL";

export const GET_ACCESS_TEMPLATE = "GET_ACCESS_TEMPLATE";
export const GET_ACCESS_TEMPLATE_SUCCESS = "GET_ACCESS_TEMPLATE_SUCCESS";
export const GET_ACCESS_TEMPLATE_FAIL = "GET_ACCESS_TEMPLATE_FAIL";
